import request from '@/api/request'
export const getusercomment = () => request({ method: 'get', url: '/api/hotel/usercomment' });
export const deletecomment = (userid, orderid) => request({ method: "get", url: `/api/hotel/deletecomment?userid=${userid}&orderid=${orderid}` })